import { TerminDetail } from 'tezaury-frontend-ts-axios';
import { useClientFetch } from '../../../context/ClientStatusContext';
import { fetchTerminDetail } from '../../../client/termin/terminDetailClient';
import { ClientStatus } from '../../../model/ClientStatus';

interface ReturnType {
  termin: TerminDetail;
  terminStatus: ClientStatus;
  reloadTermin;
}

export default (uuid: string, admin = false): ReturnType => {
  const {
    data: termin,
    status: terminStatus,
    refetch: reloadTermin,
  } = useClientFetch(fetchTerminDetail, [uuid, admin], [uuid, admin]);
  return {
    termin,
    terminStatus,
    reloadTermin,
  };
};
